"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTranslit = void 0;
const slate_1 = require("slate");
const Matcher_1 = require("../Matcher");
const withTranslit = (editor, service, opts = {}) => {
    const { insertText, deleteBackward, insertBreak } = editor;
    let matcher = null;
    let composing = false;
    const refresh = () => {
        const compiled = service.activeScheme();
        matcher = compiled ? new Matcher_1.Matcher(compiled) : null;
    };
    refresh();
    service.active.subscribe(refresh);
    const shouldRun = opts.shouldRun ?? (() => true);
    editor.insertText = (text) => {
        const m = matcher;
        if (!m || composing)
            return insertText(text);
        const sel = editor.selection;
        if (!sel || !slate_1.Range.isCollapsed(sel)) {
            m.reset();
            return insertText(text);
        }
        if (!shouldRun(editor))
            return insertText(text);
        if (text.length !== 1) {
            const flushed = m.flushAndPassthrough(text);
            applyStep(editor, flushed.replaceTail, flushed.emit);
            return;
        }
        const step = m.feed(text);
        applyStep(editor, step.replaceTail, step.emit);
    };
    editor.deleteBackward = (unit) => {
        const m = matcher;
        if (m && m.buffer.length > 0) {
            // Mid-buffer: drop a buffer char and let the user proceed; do not
            // delete from the document. Keeps Backspace-during-digraph predictable.
            m.buffer = m.buffer.slice(0, -1);
            m.lastEmitLen = 0;
            return;
        }
        if (m)
            m.reset();
        deleteBackward(unit);
    };
    editor.insertBreak = () => {
        const m = matcher;
        if (m) {
            const flushed = m.flushBuffer();
            applyStep(editor, flushed.replaceTail, flushed.emit);
            applyFinalForm(editor, m);
            m.reset();
        }
        insertBreak();
    };
    // Caller wires composition events to these via the host's editable element.
    editor.translitOnCompositionStart = () => {
        composing = true;
        matcher?.reset();
    };
    editor.translitOnCompositionEnd = () => {
        composing = false;
    };
    editor.translitMatcher = () => matcher;
    return editor;
};
exports.withTranslit = withTranslit;
const applyStep = (editor, replaceTail, emit) => {
    if (!replaceTail && !emit)
        return;
    slate_1.Editor.withoutNormalizing(editor, () => {
        if (replaceTail > 0) {
            for (let i = 0; i < replaceTail; i++)
                slate_1.Transforms.delete(editor, { distance: 1, reverse: true, unit: 'character' });
        }
        if (emit)
            slate_1.Transforms.insertText(editor, emit);
    });
};
const applyFinalForm = (editor, m) => {
    // Look at the document at the caret; if the previous char's glyph has a
    // final-form replacement, swap it in.
    const sel = editor.selection;
    if (!sel || !slate_1.Range.isCollapsed(sel))
        return;
    try {
        const before = slate_1.Editor.before(editor, sel.anchor, { unit: 'character' });
        if (!before)
            return;
        const range = { anchor: before, focus: sel.anchor };
        const text = slate_1.Editor.string(editor, range);
        const replacement = m.scheme.applyFinalForm(text);
        if (!replacement)
            return;
        slate_1.Editor.withoutNormalizing(editor, () => {
            slate_1.Transforms.delete(editor, { at: range });
            slate_1.Transforms.insertText(editor, replacement.replacement);
        });
    }
    catch { }
};
